import { render } from "./BenefitsCalculatorLandingPage.vue?vue&type=template&id=f21d2226&scoped=true"
import script from "./BenefitsCalculatorLandingPage.vue?vue&type=script&lang=js"
export * from "./BenefitsCalculatorLandingPage.vue?vue&type=script&lang=js"

import "./BenefitsCalculatorLandingPage.vue?vue&type=style&index=0&id=f21d2226&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21d2226"]])

export default __exports__